import { useMemo } from 'react';

// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';

// project imports
import AppBarStyled from './AppBarStyled';
import HeaderContent from './HeaderContent';
import Logo from 'components/logo';

import { useGetMenuMaster } from 'api/menu';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

export default function Header() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  // header content
  const headerContent = useMemo(() => <HeaderContent />, []);

  // common header. Drawer toggle lives entirely on the Drawer's own edge
  // handle (Drawer/index.jsx) now, on every breakpoint — not here.
  const mainHeader = (
    <Toolbar>
      <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
        <Logo />
      </Box>
      {headerContent}
    </Toolbar>
  );

  // app-bar params
  const appBar = {
    position: 'fixed',
    color: 'inherit',
    elevation: 0,
    sx: (theme) => ({
      borderBottom: '1px solid',
      borderBottomColor: 'divider',
      zIndex: theme.zIndex.drawer + 1,
      width: '100%'
    })
  };

  return (
    <>
      {!downLG ? (
        <AppBarStyled open={drawerOpen} {...appBar}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <AppBar {...appBar}>{mainHeader}</AppBar>
      )}
    </>
  );
}
